import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "#3a3a3a",
			d: "M10 1.666a8.336 8.336 0 0 0-8.333 8.333c0 4.6 3.733 8.334 8.333 8.334s8.333-3.734 8.333-8.334S14.6 1.666 10 1.666m-3.875 13.75A6.6 6.6 0 0 1 10 14.166c1.45 0 2.783.467 3.875 1.25A6.6 6.6 0 0 1 10 16.666a6.6 6.6 0 0 1-3.875-1.25m8.992-1.15a8.29 8.29 0 0 0-10.234 0 6.63 6.63 0 0 1-1.55-4.267A6.665 6.665 0 0 1 10 3.333a6.665 6.665 0 0 1 6.667 6.666 6.63 6.63 0 0 1-1.55 4.267"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#3a3a3a",
			d: "M10 5a2.92 2.92 0 0 0-2.917 2.916A2.92 2.92 0 0 0 10 10.833a2.92 2.92 0 0 0 2.917-2.917A2.92 2.92 0 0 0 10 4.999m0 4.166c-.692 0-1.25-.558-1.25-1.25s.558-1.25 1.25-1.25 1.25.558 1.25 1.25-.558 1.25-1.25 1.25"
		})
	]
});
const ForwardRef = forwardRef(SvgProfile);
export { ForwardRef as ReactComponent };
